import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import {  AudioManager} from "../../AudioManager";
import { WinNumberLinesFactory } from "../WinLines/WinNumberLinesFactory";
import { MarkersInfoColors, WinInfoMarker, WinsLinesInfoMarkers } from "../WinLineInfoMarkers";
import { SquareWinLineMakersFactory } from "../WinLines/SquareWinLineMakersFactory";
import { WinSquareMarkesAnimations } from "../WinLines/WinSquaresMarkersAnimations";
import { WinLinesAnimationParams } from "../WinLines/GenericWinLinesAnimation";
// namespace SlotGames {
    export class RoyalDice_2Screen extends SlotGameType1_2Screen {

        
        //protected override helpFactory: IHelpFactory = new RoyalDiceHelpFactory();
        
        //protected override panelFactory: IPanelFactory = new RoyalDicePanelFactory();

        //LED COLOR
		protected override ColorLed:string="250,0,0\n";
        
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "RoyalDice");
            this.spinnableReelsParams.topBorderWidth = 0;
            this.spinnableReelsParams.bottomBorderWidth = 0;
        }

        // public PrepareFont(resourceManager: ResourceManager)
        // {
        // 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
        // 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
        // }
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

    }

    //Help Colorized
    class RoyalDiceHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new RoyalDiceHelp(params);
        }
    }

    class RoyalDiceHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(15,19,89),rgb(45,51,166), rgb(90,97,242),rgb(45,51,166),rgb(15,19,89)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

    //Panel Colorized
    class RoyalDicePanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new RoyalDicePanel(params);
        }
    }

    class RoyalDicePanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
            };
            return color;

        }

    }

       class RoyalDiceMarkersFactory implements IWinLinesFactory {
        public CreateWinLines(params: WinLinesAnimationParams): WinSquareMarkesAnimations {
            return new RoyalDiceMarkers(params);
        }
    }


    class RoyalDiceMarkers extends WinSquareMarkesAnimations {
        protected override MarkesInfoBackground(): MarkersInfoColors {
            let color: MarkersInfoColors = {
                MarkerbackgroundColor : "linear-gradient(90deg, rgba(65,6,6,1) 0%, rgba(255,9,9,1) 35%, rgba(255,153,9,1) 55%, rgba(255,21,9,1) 75%, rgba(65,9,6,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",                
            };
            return color;
        }

    }

// }
